import { Typography, css, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  gap: "12px",
  cursor: "pointer",
  padding: "8px 8px 8px 12px"
}));
const Title = styled(Typography)(({ theme }) => ({
  flex: 1,
  color: theme.palette.grey[800],
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  gap: "4px",
  display: "flex",
  alignItems: "center"
}));
const Row = styled("div", {
  shouldForwardProp: (props) => props !== "margin"
})`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${({ margin }) => margin && css`
      margin: ${margin};
    `}
`;
const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.25px"
}));
const PatientLink = styled(Link)(({ theme }) => ({
  color: theme.palette.grey[800],
  fontWeight: 700,
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline"
  }
}));
export {
  Container,
  Description,
  PatientLink,
  Row,
  Title
};
